module.exports = __webpack_public_path__ + "media/RMR Quick Tip Change Payment Method 6.1215c297.mp4";